
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogOpenGoogle as ObiLogOpenGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-log-open-google.js';
 
 
 

 
 export const ObiLogOpenGoogle = createComponent({
   react: React,
   tagName: 'obi-log-open-google',
   elementClass: ObiLogOpenGoogleElement,
   events: {
     
   }
  });
 
 